function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M63.8251 18.271V43.694C63.8251 53.7844 55.4047 61.9651 45.0187 61.9651H43.1165L33.4026 71.3963C33.0222 71.7659 32.4959 72 31.9126 72C31.3736 72 30.8854 71.809 30.5113 71.4887L30.3464 71.3285L30.3401 71.3224L20.7086 61.9651H18.8001C8.4204 61.9651 0 53.7844 0 43.694V18.271C0 8.1807 8.4204 0 18.8064 0H45.0187C55.4047 0 63.8251 8.1807 63.8251 18.271Z",
  fill: "#FFD666"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2306 35.219C12.3791 35.219 11.3238 37.2687 12.3981 38.7487C16.575 44.5139 23.4818 48.2728 31.2859 48.2728C39.09 48.2728 45.9904 44.5077 50.1674 38.7487C51.2416 37.2687 50.1863 35.219 48.3348 35.219H14.2306Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0742 26.4937H13.902V21.0196C13.902 17.9976 16.4044 15.5454 19.4881 15.5454C22.5719 15.5454 25.0742 17.9976 25.0742 21.0196V26.4937Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M48.6693 26.4937H37.4971V21.0196C37.4971 17.9976 39.9994 15.5454 43.0832 15.5454C46.1669 15.5454 48.6693 17.9976 48.6693 21.0196V26.4937Z",
  fill: "white"
});

var SvgMarker = function SvgMarker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 72,
    viewBox: "0 0 64 72",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/marker.d260dc4c.svg";
export { ForwardRef as ReactComponent };